import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ActionDialogDataBase {
  title: string;
  message: string;
  positiveAction: boolean;
}

export interface ActionDialogDataPositive extends ActionDialogDataBase {
  positiveActionButtonText: string;
  negativeActionButtonText?: never;
}

export interface ActionDialogDataNegative extends ActionDialogDataBase {
  negativeActionButtonText: string;
  positiveActionButtonText?: never;
}

export interface ActionDialogDataBoth extends ActionDialogDataBase {
  positiveActionButtonText: string;
  negativeActionButtonText: string;
}

export type ActionDialogData =
  | ActionDialogDataBoth
  | ActionDialogDataPositive
  | ActionDialogDataNegative;

@Component({
  selector: "app-action-dialog",
  templateUrl: "./action-dialog.component.html",
  styleUrls: ["./action-dialog.component.scss"],
})
export class ActionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionDialogData
  ) {}

  hasPositiveButton(data: ActionDialogData): boolean {
    return 'positiveActionButtonText' in data;
  }
  
  hasNegativeButton(data: ActionDialogData): boolean {
    return 'negativeActionButtonText' in data;
  }
}
